<ng-template #container></ng-template>
<ng-content></ng-content>
